import * as React from "react";

export const useAsyncError = () => {
  const [_, setError] = React.useState();
  return React.useCallback(
    (e: Error) => {
      setError(() => {
        throw e;
      });
    },
    [setError],
  );
};
